import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { UnlayerDocumentTemplatesView } from '@/components/views/UnlayerDocumentTemplatesView';

export const UnlayerDocumentTemplatesPage = () => {
	return (
		<AuthenticatedPageLayout>
			<UnlayerDocumentTemplatesView />
		</AuthenticatedPageLayout>
	);
};
